import handleNotification from 'src/utils/helpers/handleNotification';

export const useNotification = () => {
  const notification = handleNotification();
  return {
    notification,
  };
};
